import linegraph from '../../../../../components/linegraph.vue'
import * as echarts from "echarts"
import iTable from "../../../../../components/Table.vue";
import IPagination from "../../../../../components/pagination.vue";
import { domainName } from "../../../../../utility/index";
import moment from 'moment';

export default {
    data() {
        return {
            formInline: {
                selectCarType: '',
                selectCarValue: '',
                carUseState: '',
                isWarningType: ''
            },
            optionsInput: [{
                value: '0',
                label: this.$t('common.all')
            }, {
                value: '1',
                label: this.$t('common.carId')
            }, {
                value: '2',
                label: this.$t('common.plateNum')
            }, {
                value: '3',
                label: this.$t('common.customNum')
            },
            {
                value: '4',
                label: this.$t('common.manufactureNum')
            }],
            stateList: [
                { id: '', name: this.$t('common.all') },
                { id: '0', name: this.$t('common.normal') },
                { id: '1', name: this.$t('common.abnormal') },
            ],
            UseStateList: [{
                id: '',
                name: this.$t('common.all')
            }, {
                id: '0',
                name: this.$t('common.normal')
            }, {
                id: '1',
                name: this.$t('SafeManagement.stop')
            }, {
                id: '2',
                name: this.$t('SafeManagement.stoped')
            }],
            isShow: true,
            dateTime: '',
            optionPie: {},
            pieLoading: false,
            finishCheck: '',
            unfinishCheck: '',
            isLoading: false,
            option: [],
            normalRate: '',
            abnormalRate: '',
            orgId: '',
            height: '500',
            list: [],
            options: {
                stripe: true,
                border: true,
                loading: false,
                highlightCurrentRow: false,
                mutiSelect: true,
                serialNumber: true,
            },
            columns: [
                {
                    prop: "carId",
                    label: this.$t('common.carId'),
                    align: "center",
                },
                {
                    prop: "manufactureNum",
                    label: this.$t('common.manufactureNum'),
                    align: "center",
                    width: "150px"
                },
                {
                    prop: "customNum",
                    label: this.$t('common.customNum'),
                    align: "center",
                    width: "120px"
                },
                {
                    prop: "plateNum",
                    label: this.$t('common.plateNum'),
                    align: "center",
                    width: "120px"
                },
                {
                    prop: "orgName",
                    label: this.$t('common.orgName'),
                    align: "center",

                },
                {
                    prop: "happenTime",
                    label: this.$t('common.date'),
                    align: "center",
                    width: "160px"

                },
                {
                    prop: "carUseState",
                    label: this.$t('SafeManagement.carUseState'),
                    align: "center",
                    width: "160px",
                    render: (h, params) => {
                        return h('el-tag', {
                            props: { type: params.row.carUseState === null ? '' : params.row.carUseState === 0 ? 'success' : params.row.carUseState === 1 ? 'warning' : 'danger' }
                        }, params.row.carUseState === null ? '' : params.row.carUseState === 0 ? this.$t('common.normal') : params.row.carUseState === 1 ? this.$t('SafeManagement.stop') : this.$t('SafeManagement.stoped'))
                    }

                },
                {
                    prop: "isWarning",
                    label: this.$t('SafeManagement.InspectionResults'),
                    align: "center",
                    render: (h, params) => {
                        return h('el-tag', {
                            props: { type: params.row.isWarning === '' ? '' : params.row.isWarning === 0 ? 'success' : 'danger' }
                        }, params.row.isWarning === '' ? '' : params.row.isWarning === 0 ? this.$t('common.normal') : this.$t('common.abnormal'))
                    }

                },
                {
                    prop: "checkFilePath",
                    label: this.$t('SafeManagement.InspectionPersonnel'),
                    align: "center",
                    render: (h, params) => {
                        const imageUrl = params.row.checkFilePath || '';
                        if (!imageUrl) {
                            return h('span', '无图片');
                        }
                        return h('el-image', {
                            props: {
                                src: imageUrl,
                                fit: 'contain',
                                previewSrcList: [imageUrl],
                                previewTeleported: true
                            },
                            style: {
                                backgroundColor: '#fff',
                                border: '1px solid #ddd',
                                marginTop: '8px'
                            },
                            on: {
                                error: () => { console.error('图片加载失败'); }
                            }
                        });
                    }

                }
            ],
            dialogDetailsFormVisible: false,
            operates: {
                width: 100,
                fixed: "right",
                list: [
                    {
                        id: '1',
                        show: true,
                        icon: 'iconfont iconicon-chakanxq',
                        plain: true,
                        disabled: false,
                        method: (index, row) => {
                            this.dialogDetailsFormVisible = true
                            this.queryDetails(index, row)
                        }
                    }
                ],
            },
            formLabelWidth: '300px',
            DetailsRorm: {
                carUseState: '',
                radioList: [],
                carMileage: '',
                remarks: '',
                filePath: ''
            },
            currentPage: 1,
            pageSize: 10,
            total: 1,
            imageUrl: '',
            FileList: [],
            selected: [],
        }
    },
    components: {
        linegraph,
        iTable,
        IPagination
    },
    created() {
        this.getDate()
    },
    methods: {
        getDate() {
            this.dateTime = moment().format("YYYY-MM-DD");
        },
        changeTime() {
            this.getCheckRate()
            this.getStateRate()
            this.getMonthOrderList()
        },
        getCheckRate() {
            this.pieLoading = true
            let param = {
                orgId: Number(this.orgId),
                dateTime: this.dateTime,
            }
            this.$store.dispatch("checkManagement/GET_SELECTCHECKRATE", param).then(res => {
                console.log(res)
                if (res) {
                    console.log(res)
                    if (res.data.code == 200) {
                        this.finishCheck = res.data.data.finishSpotCheckRate.indexOf('%') > -1 ? res.data.data.finishSpotCheckRate.split('%')[0] : ''
                        this.unfinishCheck = res.data.data.unfinishedSpotCheckRate.indexOf('%') > -1 ? res.data.data.unfinishedSpotCheckRate.split('%')[0] : ''
                        this.CheckRate(this.finishCheck, this.unfinishCheck)
                    }
                }
                this.pieLoading = false
            }).catch(err => {
                this.pieLoading = false
            })
        },
        CheckRate(finishCheck, unfinishCheck) {
            let option = {
                tooltip: {
                    trigger: 'item',
                    formatter: "{a} <br/>{b} : {c} ({d}%)"
                },
                legend: {
                    orient: 'vertical',
                    left: '5%',
                    top: 'center',
                    itemWidth: 10,
                    itemHeight: 10,
                    itemGap: 20,
                    textStyle: {
                        color: '#fff'
                    },
                    data: [this.$t('SafeManagement.Checked'), this.$t('SafeManagement.Unchecked')]
                },
                series: [
                    {
                        name: this.$t('common.number'),
                        type: 'pie',
                        radius: ['45%', '65%'],
                        center: ['60%', '50%'],
                        data: [
                            { value: finishCheck, name: this.$t('SafeManagement.Checked') },
                            { value: unfinishCheck, name: this.$t('SafeManagement.Unchecked') },
                        ],
                        label: {
                            color: '#fff'
                        },
                        itemStyle: {
                            normal: {
                                color: function (params) {
                                    var colorList = [
                                        ['#fc5a62', '#f69d70'],
                                        ['#437cfc', '#48e2f9'],
                                    ];
                                    return new echarts.graphic.LinearGradient(0, 0, 0, 1,

                                        [
                                            { offset: 0, color: colorList[params.dataIndex][0] },
                                            { offset: 1, color: colorList[params.dataIndex][1] }
                                        ]);
                                },
                            }

                        }
                    }
                ]
            }
            this.optionPie = option
        },

        getStateRate() {
            this.pieLoading = true
            let param = {
                orgId: Number(this.orgId),
                dateTime: this.dateTime,
            }
            this.$store.dispatch("checkManagement/GET_SELECTSTATERATE", param).then(res => {
                if (res) {
                    if (res.data.code == 200) {
                        this.abnormalRate = res.data.data.abnormalIsWarningRate.indexOf('%') > -1 ? res.data.data.abnormalIsWarningRate.split('%')[0] : ""
                        this.normalRate = res.data.data.normalIsWarningRate.indexOf('%') > -1 ? res.data.data.normalIsWarningRate.split('%')[0] : ''
                        this.StateRate(this.normalRate, this.abnormalRate)
                    }
                }
                this.pieLoading = false
            }).catch(err => {
                this.pieLoading = false
            })
        },
        StateRate(normalRate, abnormalRate) {
            let option = {
                tooltip: {
                    trigger: 'item',
                    formatter: "{a} <br/>{b} : {c} ({d}%)"
                },
                legend: {
                    orient: 'vertical',
                    left: '5%',
                    top: 'center',
                    itemWidth: 10,
                    itemHeight: 10,
                    itemGap: 20,
                    textStyle: {
                        color: '#fff'
                    },
                    data: [this.$t(' .normal'), this.$t(' .abnormal'),]
                },
                series: [
                    {
                        name: this.$t('common.number'),
                        type: 'pie',
                        radius: ['45%', '65%'],
                        center: ['60%', '50%'],
                        data: [
                            { value: normalRate, name: this.$t('common.normal') },
                            { value: abnormalRate, name: this.$t('common.abnormal') }
                        ],
                        label: {
                            color: '#fff'
                        },
                        itemStyle: {
                            normal: {
                                color: function (params) {
                                    var colorList = [
                                        ['#56d1a9', '#baeb46'],
                                        ['#8e70f9', '#da609f'],
                                    ];
                                    return new echarts.graphic.LinearGradient(0, 0, 0, 1,

                                        [
                                            { offset: 0, color: colorList[params.dataIndex][0] },
                                            { offset: 1, color: colorList[params.dataIndex][1] }
                                        ]);
                                },
                            }

                        }
                    }
                ]
            }
            this.option = option
        },

        getMonthOrderList() {
            console.log(this.columns)
            let param = {
                orgId: Number(this.orgId),
                selectCarType: this.formInline.selectCarType,
                selectCarValue: this.formInline.selectCarValue,
                carUseState: this.formInline.carUseState,
                isWarningType: this.formInline.isWarningType,
                dateTime: this.dateTime,
                pageNum: this.currentPage,
                pageSize: this.pageSize,
            };
            this.$store.dispatch('checkManagement/GET_SELECTCHECKLIST', param).then(res => {
                if (res) {
                    if (res.data.code == 200) {
                        this.list = res.data.data.list
                        this.$refs.page.CommandTotal = res.data.data.total
                    }
                }
            }).catch(err => { })
        },
        onSearch() {
            this.currentPage = 1
            this.getMonthOrderList()
        },
        onClear() {
            this.formInline = {
                selectCarType: '',
                selectCarValue: '',
                carUseState: '',
                isWarningType: ''
            },
                this.getMonthOrderList()
        },
        queryDetails(index, row) {
            this.DetailsRorm.carUseState = row.carUseStateStr
            this.DetailsRorm.radioList = row.spotCheckRecordVoList
            this.DetailsRorm.carMileage = row.carMileage
            this.DetailsRorm.remarks = row.remark
            this.DetailsRorm.filePath = row.filePath
            this.imageUrl = row.filePath
        },
        downCar() {
            if (domainName) {
                if (domainName.split(':')[0] !== 'localhost') {
                    let url = `https://${domainName}/v1/getExportExcel/uploadEventSpotCheckRecordList?orgId=${Number(this.orgId)}&selectCarType=${this.formInline.selectCarType}&selectCarValue=${this.formInline.selectCarValue}&carUseState=${this.formInline.carUseState}&isWarningType=${this.formInline.isWarningType}&dateTime=${this.dateTime}`
                    location.href = url
                } else {
                    let host = 'localhost:8080'
                    let url = `https://${host}/v1/getExportExcel/uploadEventSpotCheckRecordList?orgId=${Number(this.orgId)}&selectCarType=${this.formInline.selectCarType}&selectCarValue=${this.formInline.selectCarValue}&carUseState=${this.formInline.carUseState}&isWarningType=${this.formInline.isWarningType}&dateTime=${this.dateTime}`
                    location.href = url
                }
            }
        },
        handleSelectionChange(val) {
            this.selected = val
        },
        changeSize(item) {
            this.pageSize = item.pageSize
            this.currentPage = item.pageNum
            this.getMonthOrderList()
        },
    }
}
